import { supabase } from "@/integrations/supabase/client";

const API_URL = import.meta.env.VITE_API_URL;

const makeAuthorizedPostRequest = async (endpoint: string): Promise<void> => {
  const { data: { session } } = await supabase.auth.getSession();
  
  if (!session) {
    throw new Error("No active session");
  }

  const response = await fetch(`${API_URL}${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session.access_token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status} ${response.statusText}`);
  }
};

export const regenerateApiKey = async (): Promise<void> => {
  await makeAuthorizedPostRequest('/api/v1/api/regenerate-api-key');
};

export const regenerateWebhookSecret = async (): Promise<void> => {
  await makeAuthorizedPostRequest('/api/v1/api/regenerate-webhook-secret');
};

export const updateWebhookUrl = async (url: string): Promise<void> => {
  const { data, error } = await supabase.rpc('update_webhook_url', {
    new_url: url
  });

  if (error) {
    throw new Error(error.message || "Ошибка обновления webhook URL");
  }
};